import { CometChatCalls } from '@cometchat/calls-sdk-javascript';
import { useState } from 'react';
import Avatar from '../Avatar/Avatar';
import { ProfileDialog } from '../Profile/ProfileDialog';
import './AccountMenu.css';

/**
 * The signed-in account: an avatar button that opens the Profile popup (identity, call readiness,
 * features, versions, Sign out). It used to open a small menu with only the name, Sign out and the
 * app version; Android and iOS open the same Profile screen from their avatar.
 *
 * One component so the shell's pane header and the narrow History screen open the same popup.
 */
export function AccountMenu({ onLogout, size = 32 }: { onLogout: () => void; size?: number }) {
  const [open, setOpen] = useState(false);
  const user = CometChatCalls.getLoggedInUser();
  const name = user?.name || 'Guest user';

  return (
    <div className="md-account">
      <button
        type="button"
        className="md-account__trigger"
        aria-haspopup="dialog"
        aria-label={`Profile: ${name}`}
        onClick={() => setOpen(true)}>
        <Avatar size={size} name={user?.name || ''} imageUrl={user?.avatar} />
      </button>

      {open && (
        <ProfileDialog
          onClose={() => setOpen(false)}
          onLogout={() => {
            setOpen(false);
            onLogout();
          }}
        />
      )}
    </div>
  );
}
